export function InvoiceDetailsEmptySelection() {
  return (
    <div className="border-c-border text-c-card-muted flex h-full items-center justify-center rounded-t-none rounded-b-xl border px-2 text-sm">
      Select an invoice row to view details.
    </div>
  );
}
